const Security = props => {
    return (
        <svg className={props.className || ""} viewBox="0 -960 960 960" ><path d="M480-100.77q-129.77-35.39-214.88-152.77Q180-370.92 180-516v-230.15l300-112.31 300 112.31V-516q0 145.08-85.12 262.46Q609.77-136.16 480-100.77Zm0-63.23q97-30 162-118.5T718-480H480v-314.62L240-705v206.62q0 7.38 2 18.38h238v316Z"/></svg>
    )
}

export default Security;